var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{domProps:{"innerHTML":_vm._s(_vm.userToDisplay ? _vm.userToDisplay.fullname : _vm.$t('users.not_exist'))}})}
var staticRenderFns = []

export { render, staticRenderFns }